import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTask } from 'app/models/search-response.model';
import { Tarea } from 'app/models/tareas.model';
import { FormTypeWidgetComponent } from 'app/modules/GlobalComponents/id-formulario-widget.component';
import { StatusStickerComponent } from 'app/modules/GlobalComponents/status sticker.component';
import { SearchParams } from '../search-params';
import { from, Subject, takeUntil } from 'rxjs';
import { SearchService } from '../search.service';
import { environment as env } from 'environments/environments';

@Component({
    selector: 'card-task',
    templateUrl: 'card-task.component.html',
    imports:[
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatButtonModule,

        //global componets
        FormTypeWidgetComponent,
        StatusStickerComponent
    ]
})

export class CardTaskComponent implements OnInit {
    @Input() tasks:DataTask
    @Input() tipoPaginacion: number; 
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = ['avatar','detalleSolicitud', 'seccion', 'estado', 'actions'];
    pageSizes = 10

    _unsubscribe: Subject<any> = new Subject()
    value:string =  ''
    tipoGestiones:number
    tipoSolicitudes:number
    inicio:number = 0
    max:number = 10

    constructor(private router: Router, private activeroute: ActivatedRoute, private SearchService: SearchService) {
        this.tipoGestiones= env.TIPOLOGIA_ID_GESTIONES
        this.tipoSolicitudes= env.TIPOLOGIA_ID_SOLICITUDES
    }

    ngOnInit() {
        this.activeroute.params.pipe(takeUntil(this._unsubscribe)).subscribe(params => {
          if (params.value) {
            this.value = params.value;
          }
        });

    }
      

    openTaskDetails(task_uuid: string){
        this.router.navigateByUrl(`/task-details/task/${task_uuid}`)
    }


    ngAfterViewInit() {
        this.paginator.page
            .pipe(takeUntil(this._unsubscribe))
            .subscribe(event => {
                const startIndex = event.pageIndex * event.pageSize;
                const endIndex = startIndex + event.pageSize;
                this.inicio = startIndex;
                this.max = endIndex;
                this.search(this.tipoPaginacion, this.inicio, this.max);
            });
    }

    search(tipoPaginacion: number, inicio: number, max: number) {
        let params: SearchParams = {
            tipoPaginacion: tipoPaginacion,
            inicio: inicio,
            max: max,
            asc: false,
            busqueda: this.value
        };
    
        this.SearchService.searchTask(params)
    
    }
    
    ngOnDestroy() {
        this._unsubscribe.next(null);
        this._unsubscribe.complete();
    }
}